import ISO_CODE_TO_SYMBOL_MAP from './iso-code-to-symbol-map';

const injectorName = 'ws.common.utils';
export default injectorName;

angular.module(injectorName, [])
  .constant('ISO_CODE_TO_SYMBOL_MAP', ISO_CODE_TO_SYMBOL_MAP);



// WEBPACK FOOTER //
// ./src/utils/index.js